import { BreakpointObserver } from '@angular/cdk/layout';
import { inject, Injectable, Signal } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { map } from 'rxjs';

// Kept in sync with Tailwind's `md` screen (768px), so `isMobile()` is true exactly where `max-md:` classes apply.
export const MOBILE_MEDIA_QUERY = '(max-width: 767.98px)';

@Injectable({
  providedIn: 'root',
})
export class ViewportService {
  private readonly breakpointObserver = inject(BreakpointObserver);

  public readonly isMobile: Signal<boolean> = toSignal(
    this.breakpointObserver.observe(MOBILE_MEDIA_QUERY).pipe(map((state) => state.matches)),
    { initialValue: this.breakpointObserver.isMatched(MOBILE_MEDIA_QUERY) },
  );
}
